export const userTypes = {
    student: 'student',
    teacher: 'teacher',
    admin: 'admin',
};